import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Button,
  Flex,
  HStack,
  Heading,
  Image,
  Link,
  Text,
} from "@chakra-ui/react";
import { FaArrowRight, FaBolt } from "react-icons/fa6";

const RETAILERS = [
  { src: "/pnp.jpg", alt: "Pick n Pay" },
  { src: "/chk.jpg", alt: "Checkers" },
  { src: "/dis.jpg", alt: "Dis-Chem" },
  { src: "/cli.jpg", alt: "Clicks" },
];

const Hero = ({ children }) => {
  return (
    <Box
      as="header"
      maxW="1240px"
      mx="auto"
      px="24px"
      pt="64px"
      pb="90px"
      textAlign="center"
      position="relative"
    >
      <Link
        as="a"
        href="#product"
        display="inline-flex"
        alignItems="center"
        gap="8px"
        px="14px"
        py="6px"
        borderRadius="9999px"
        bg="rgba(255,255,255,0.05)"
        border="1px solid rgba(255,255,255,0.10)"
        fontSize="12px"
        fontWeight={500}
        color="rgba(230,236,245,0.85)"
        mb="24px"
        textDecoration="none"
        _hover={{
          textDecoration: "none",
          "& .lp-eyebrow-arrow": { transform: "translateX(3px)" },
        }}
        sx={{ "& .lp-eyebrow-arrow": { transition: "transform 0.3s ease" } }}
      >
        <Box
          w="16px"
          h="16px"
          borderRadius="5px"
          bg="linear-gradient(135deg, #04aec1, #ec4899)"
          display="grid"
          placeItems="center"
          color="white"
        >
          <FaBolt size={9} />
        </Box>
        <Text as="span">New · Forecast & inventory insights, live now</Text>
        <Box className="lp-eyebrow-arrow" color="rgba(230,236,245,0.5)" display="inline-flex">
          <FaArrowRight size={10} />
        </Box>
      </Link>

      <Heading
        as="h1"
        fontSize="clamp(44px, 7vw, 84px)"
        lineHeight="0.98"
        letterSpacing="-0.035em"
        fontWeight={700}
        mx="auto"
        maxW="1000px"
        mb="22px"
        color="white"
      >
        Sales reporting,
        <br />
        <Box
          as="span"
          className="lp-grad-text"
          sx={{
            background:
              "linear-gradient(90deg, #74ebd5 0%, #6366f1 50%, #ec4899 100%)",
            backgroundSize: "200% auto",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            animation: "lp-shine 6s linear infinite",
          }}
        >
          decoded for suppliers.
        </Box>
      </Heading>

      <Text
        fontSize="clamp(15px, calc(1.4vw + 8px), 19px)"
        color="rgba(230,236,245,0.74)"
        lineHeight="1.55"
        maxW="640px"
        mx="auto"
        mb="32px"
      >
        Spearbi pulls every store, every SKU, every retailer feed into one
        frosted-glass dashboard. Stop chasing CSVs — start shipping the right
        product to the right shelf, on time.
      </Text>

      <Flex justify="center" gap="12px" wrap="wrap" mb="36px">
        <Button
          as={RouterLink}
          to="/contact-us"
          variant="unstyled"
          display="inline-flex"
          alignItems="center"
          gap="8px"
          color="white"
          bg="linear-gradient(135deg, #04aec1 0%, #6366f1 60%, #ec4899 120%)"
          backgroundSize="200% 200%"
          backgroundPosition="0% 50%"
          borderRadius="9999px"
          fontSize="14px"
          fontWeight={600}
          px="24px"
          py="13px"
          h="auto"
          boxShadow="0 10px 24px -8px rgba(99,102,241,0.55), inset 0 1px 0 rgba(255,255,255,0.25)"
          transition="all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)"
          _hover={{
            transform: "translateY(-2px)",
            backgroundPosition: "100% 50%",
            boxShadow:
              "0 14px 32px -10px rgba(236,72,153,0.55), inset 0 1px 0 rgba(255,255,255,0.3)",
          }}
        >
          Book a demo
          <FaArrowRight size={11} />
        </Button>
      </Flex>

      <Flex justify="center" align="center" gap="28px" wrap="wrap" mt="12px">
        <Text
          fontSize="11px"
          color="rgba(230,236,245,0.5)"
          textTransform="uppercase"
          letterSpacing="0.14em"
          fontWeight={600}
        >
          Trusted with feeds from
        </Text>
        <HStack spacing="18px">
          {RETAILERS.map((r) => (
            <Image
              key={r.alt}
              src={r.src}
              alt={r.alt}
              h="28px"
              opacity={0.85}
              transition="opacity 0.25s ease"
              _hover={{ opacity: 1 }}
            />
          ))}
        </HStack>
      </Flex>

      {children}
    </Box>
  );
};

export default Hero;
